module.exports = __webpack_public_path__ + "static/img/icon_remt_svc_step_01.a30642f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/custcntr/icon_remt_svc_step_01.svg
// module id = 2YuG
// module chunks = 10